// API Configuration
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// BURNZ Team Wallet Address
export const BURNZ_TEAM_WALLET = "addr1qxtqu8cvxjxrh035s6f9k698rglpguz4xs8gw5edja2z6fp4x79ct53d3gpl0g3w4eyvnlv09nkjqvrkspfxjza3h0eqy34flk";

// External Links
export const DISCORD_INVITE = "https://discord.gg/74wEdNQ5tC";
export const UEX_REFERRAL = "https://uex.us/?ref=5jcsh81dhaos";

// Logo URL
export const BURNZ_LOGO = "https://customer-assets.emergentagent.com/job_nftrescue/artifacts/q8wiedw1_burnz_logo_v4_transparent.gif";

// Animations
export const fadeIn = { hidden: { opacity: 0, y: 20 }, visible: { opacity: 1, y: 0, transition: { duration: 0.4 } } };
export const stagger = { visible: { transition: { staggerChildren: 0.08 } } };

// Project Images
export const PROJECT_IMAGES = {
  "1": "https://images.unsplash.com/photo-1639762681485-074b7f938ba0?w=400&h=400&fit=crop",
  "2": "https://images.unsplash.com/photo-1642104704074-907c0698cbd9?w=400&h=400&fit=crop",
  "3": "https://images.unsplash.com/photo-1644361566696-3d442b5b4823?w=400&h=400&fit=crop",
  "4": "https://images.unsplash.com/photo-1634973357973-f2ed2657db3c?w=400&h=400&fit=crop",
  "5": "https://images.unsplash.com/photo-1620321023374-d1a68fbc720d?w=400&h=400&fit=crop",
};

// Demo NFTs for selection
export const DEMO_NFTS = [
  { id: "nft1", name: "Neon Ape #1234", collection: "Neon Apes Genesis", image: PROJECT_IMAGES["1"], xpValue: 100, burnzValue: 10 },
  { id: "nft2", name: "Cyber Punk #567", collection: "Cyber Punks CNF", image: PROJECT_IMAGES["2"], xpValue: 100, burnzValue: 10 },
  { id: "nft3", name: "Meta Monkey #890", collection: "Meta Monkeys DAO", image: PROJECT_IMAGES["4"], xpValue: 100, burnzValue: 10 },
  { id: "nft4", name: "Pixel Warrior #321", collection: "Pixel Warriors", image: PROJECT_IMAGES["5"], xpValue: 100, burnzValue: 10 },
  { id: "nft5", name: "Neon Ape #5678", collection: "Neon Apes Genesis", image: PROJECT_IMAGES["1"], xpValue: 100, burnzValue: 10 },
  { id: "nft6", name: "Cyber Punk #901", collection: "Cyber Punks CNF", image: PROJECT_IMAGES["2"], xpValue: 100, burnzValue: 10 },
  { id: "nft7", name: "Neon Ape #9012", collection: "Neon Apes Genesis", image: PROJECT_IMAGES["1"], xpValue: 100, burnzValue: 10 },
  { id: "nft8", name: "Meta Monkey #456", collection: "Meta Monkeys DAO", image: PROJECT_IMAGES["4"], xpValue: 100, burnzValue: 10 },
  { id: "nft9", name: "Cyber Punk #234", collection: "Cyber Punks CNF", image: PROJECT_IMAGES["2"], xpValue: 100, burnzValue: 10 },
  { id: "nft10", name: "Pixel Warrior #789", collection: "Pixel Warriors", image: PROJECT_IMAGES["5"], xpValue: 100, burnzValue: 10 },
  { id: "nft11", name: "Neon Ape #3456", collection: "Neon Apes Genesis", image: PROJECT_IMAGES["1"], xpValue: 100, burnzValue: 10 },
  { id: "nft12", name: "Meta Monkey #123", collection: "Meta Monkeys DAO", image: PROJECT_IMAGES["4"], xpValue: 100, burnzValue: 10 },
];
